import AuthModel from '../models/AuthModel'

export const login = (formData) => {
    return (dispatch) => {
        AuthModel.login(formData, (r) => {
            if (r.auth_token) {
                dispatch(loginSuccess(r))
            } else {
                dispatch(loginError(r.error))
            }
        })
    }
}

export const loginSuccess = (user) => {
    return {
        type: 'LOGIN',
        id: user.id,
        email: user.email,
        username: user.username,
        entidade: user.entidade,
        authToken: user.auth_token
    }
}

export const loginError = (error) => {
    return {
        type: 'LOGIN_ERROR',
        error
    }
}

export const loginReset = () => {
    return {
        type: 'LOGIN_RESET',
        complete: false,
        authToken: '',
        username: '',
        error: false
    }
}

export const logout = () => {
    AuthModel.logout()
    return {
        type: 'LOGOUT',
        complete: false,
        authToken: '',
        username: '',
        id: null,
        error: false
    }
}

export const recoverStart = (formData) => {
    return (dispatch) => {
        AuthModel.recoverStart(formData, (r) => {
            if (!r.error) {
                dispatch(recoverStartSuccess(r))
            } else {
                dispatch(recoverStartError(r.error))
            }
        })
    }
}

export const recoverStartSuccess = (result) => {
    return {
        type: 'RECOVER_START_SUCCESS',
        result
    }
}

export const recoverStartError = (error) => {
    return {
        type: 'RECOVER_START_ERROR',
        error
    }
}

export const recoverStartReset = () => {
    return {
        type: 'RECOVER_START_RESET',
        complete: false,
        username: '',
        error: false
    }
}

export const recover = (formData) => {
    return (dispatch) => {
        AuthModel.recover(formData, (r) => {
            if (!r.error) {
                dispatch(recoverSuccess(r))
            } else {
                dispatch(recoverError(r.error))
            }
        })
    }
}

export const recoverSuccess = (result) => {
    return {
        type: 'RECOVER_SUCCESS',
        result
    }
}

export const recoverError = (error) => {
    return {
        type: 'RECOVER_ERROR',
        error
    }
}

export const recoverReset = () => {
    return {
        type: 'RECOVER_RESET',
        complete: false,
        recover_token: '',
        error: false
    }
}



// WEBPACK FOOTER //
// ./src/actions/auth.js